<template>
	<div class="container print-page" id="print-page-3">
		<div class="row print-row">
			<div class="col">
				<h3 class="avoid-page-break-after">Ability Details</h3>
			</div>
		</div>
		<details-racial/>
		<details-theme/>
		<details-feats/>
		<details-class/>

		<details-armor-upgrades/>

		<div v-if="hasCompanion[currentLevel]">
			<div class="row print-row mt-3" v-if="Array.isArray(Character.Levels[currentLevel].Companion.Specials||null)">
				<div class="col">
					<h3 class="avoid-page-break-after">Companion</h3>
				</div>
			</div>
			<div class="row print-row mt-3" v-for="(special, specialID) in companionSpecials" :key="'companionSpecialList-'+specialID">
				<div class="col-2">
					<strong>{{special.Name}} ({{special.Type}})</strong>
				</div>
				<div class="col-10 pre">{{special.Description}}</div>
			</div>
		</div>

		<div class="row print-row mt-3" v-if="Character.Equipment.Equipped.length > 0 || Character.Equipment.Augmentation.length > 0 || Character.Equipment.Magic.length > 0">
			<div class="col">
				<h3 class="avoid-page-break-after">Equipment</h3>
			</div>
		</div>

		<details-equipment-equipped/>
		<details-equipment-augments/>
		<details-equipment-magic/>

	</div>
</template>

<script>
import {mapGetters} from 'vuex'

let components = {}

components.DetailsRacial = () => import('@/components/print/details/Racial.vue')
components.DetailsTheme = () => import('@/components/print/details/Theme.vue')
components.DetailsFeats = () => import('@/components/print/details/Feats.vue')
components.DetailsClass = () => import('@/components/print/details/Class.vue')
components.DetailsArmorUpgrades = () => import('@/components/print/details/ArmorUpgrades.vue')

components.DetailsEquipmentEquipped = () => import('@/components/print/details/EquipmentEquipped.vue')
components.DetailsEquipmentAugments = () => import('@/components/print/details/EquipmentAugments.vue')
components.DetailsEquipmentMagic = () => import('@/components/print/details/EquipmentMagic.vue')

export default {
	components,
	computed: {
		Character: function(){
			return this.$store.state.Character
		},
		...mapGetters([
			'currentLevel',
		]),
		...mapGetters('character/companions',[
			'hasCompanion',
		]),
	}
}
</script>

<style scoped>

</style>